// Test IDs for the GM patch-file upload tool (uploads to
// vision_lite/downloads/game/Data or /events, served to the WoW launcher).

export const PATCHES_ADMIN = {
  page: 'patches-admin-page',
  guard: 'patches-admin-guard',
  dropzone: 'patches-admin-dropzone',
  fileInput: 'patches-admin-file-input',
  eventCheckbox: 'patches-admin-event-checkbox',
  selectedRow: 'patches-admin-selected-row',
  uploadButton: 'patches-admin-upload-button',
  existingRow: 'patches-admin-existing-row',
  moveButton: 'patches-admin-move-button',
  overwriteDialog: 'patches-admin-overwrite-dialog',
  overwriteConfirmButton: 'patches-admin-overwrite-confirm-button',
  overwriteCancelButton: 'patches-admin-overwrite-cancel-button',
  progressBar: 'patches-admin-progress-bar',
};
